import { motion } from "framer-motion";
import { fadeUp, staggerContainer, viewportOnce } from "@/animations/motion";

/** Technology stack shown as tidy chips (no logo wall). */
export function TechStackChips({ items }: { items: string[] }) {
  return (
    <motion.div
      variants={staggerContainer(0.04)}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      className="flex flex-wrap gap-3"
    >
      {items.map((item) => (
        <motion.span
          key={item}
          variants={fadeUp}
          className="rounded-xl border border-border bg-card px-4 py-2.5 font-heading text-sm font-semibold text-foreground transition-all duration-300 hover:-translate-y-0.5 hover:border-accent/40 hover:text-primary"
        >
          {item}
        </motion.span>
      ))}
    </motion.div>
  );
}
